'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/lib/auth-context';
import { Loader2 } from 'lucide-react';
import { Logo } from '@/components/logo';

export default function Home() {
  const router = useRouter();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        // Not logged in, redirect to login
        router.push('/login');
      } else {
        // User is logged in, redirect based on role
        if (user.role === 'citizen') {
          router.push('/citizen');
        } else if (user.role === 'provider') {
          router.push('/provider');
        } else if (user.role === 'admin') {
          router.push('/admin');
        } else {
          router.push('/login');
        }
      }
    }
  }, [user, loading, router]);

  // Show loading spinner while checking auth
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="text-center animate-fade-in space-y-4">
        <div className="flex justify-center">
          <Logo size={120} />
        </div>
        <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto" />
        <p className="text-gray-600">Loading...</p>
      </div>
    </div>
  );
}
